import { Rule } from '~/types/pricings';

export const updateRuleCurrency = (rule: Rule, currency: string) => {
  if (rule?.type === 'fixed') {
    return {
      ...rule,
      amount: { currency, value: rule?.amount?.value },
    };
  } else {
    return {
      ...rule,
      percent: rule?.percent,
      maxAmount: { currency, value: rule?.maxAmount?.value },
      minAmount: { currency, value: rule?.minAmount?.value },
    };
  }
};
